<template>
  <span :class="spinClass">
    <v-icon @click="handleRefresh">mdi-refresh</v-icon>
  </span>
</template>

<script>
export default {
  name: 'refresh-spinner',
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return { }
  },
  computed: {
    spinClass () {
      return this.value ? 'custom-loader' : ''
    }
  },
  methods: {
    handleRefresh (event) {
      this.$emit('click', 'Refresh Requested')
    }
  }

}
</script>
